import type { ProductsType } from 'redux-store/slices/products/types';

const productsOrder = ['week', 'month', 'year', '2-year', 'lifetime'];

export default function filterSmallerProducts(
  products: ProductsType,
): ProductsType {
  let biggestProductIndex = 0;
  products.forEach(product => {
    if (product.isCurrent) {
      const productIndex = productsOrder.findIndex(interval => {
        return product.interval === interval;
      });

      if (productIndex > biggestProductIndex) {
        biggestProductIndex = productIndex;
      }
    }
  });

  const filteredIntervals = productsOrder.slice(0, biggestProductIndex);

  return products.filter(
    product => !filteredIntervals.includes(product.interval),
  );
}
